module.exports = __webpack_public_path__ + "assets/img/dashenlin.6e03b6ee.png";